import React, { useState } from 'react';
import Item from './Item';
import StoryContext from '../contexts/StoryContext';
import PreviewCanvas from './previews/PreviewCanvas';

const List = () => {
  const [hoveredStory, setHoveredStory] = useState(null);
  // Positions are keyed by slug so they survive re-renders (e.g. hover state changes)
  const positionsRef = React.useRef({});

  const getPosition = (slug) => {
    if (!positionsRef.current[slug]) {
      positionsRef.current[slug] = {
        top: `${Math.floor(Math.random() * 50)}vh`,
        left: `${Math.floor(Math.random() * 50)}vw`,
        transform: `rotate(${Math.floor(Math.random() * 4) * 90}deg)`,
      };
    }
    return positionsRef.current[slug];
  };

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%'}}>
      <StoryContext.Consumer>
        {data =>
          data.searchedStories.map((story, key) => {
            const randomPosition = getPosition(story.slug);
            return (
              <div
                key={key}
                style={{
                  position: 'absolute',
                  transform: `translate(${randomPosition.left}, ${randomPosition.top}) ${randomPosition.transform}`,
                }}
              >
                <Item
                  item={story}
                  onRemoveItem={data.onRemoveStory}
                  onHoverStart={() => setHoveredStory(story)}
                  onHoverEnd={() => setHoveredStory(null)}
                />
              </div>
            );
          })
        }
      </StoryContext.Consumer>
      <div className="square-container">
        <div
          className="square"
          style={{ visibility: hoveredStory ? 'visible' : 'hidden' }}
        >
          {hoveredStory && (
            <PreviewCanvas
              key={hoveredStory.slug}
              interactive={hoveredStory.interactive}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default List;
